import { HttpHandler, HttpInterceptor, HttpRequest, } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BearerAuthSchema, AuthInterceptorExcludeUrls } from '../constants/constants';
import { AccessCodeService } from '../services/access-code.service';
import { AccessTokenService } from '../services/access-token-service';
import { forkJoin, merge, of, partition } from 'rxjs';
import { debounceTime, filter, map, mergeMap, share, switchMap, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthInterceptor implements HttpInterceptor {
    private canRefresh = true;

    constructor(
        private accessCodeService: AccessCodeService,
        private accessTokenService: AccessTokenService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        if (AuthInterceptorExcludeUrls.find((url) => req.url.includes(url))) {
            return next.handle(req);
        }

        if (!this.accessTokenService.getToken()) {
            return next.handle(req);
        }

        return this.doRefreshIfRequired()
            .pipe(
                mergeMap(accessToken => {
                    // console.log('after interception: ', req.url);

                    return next.handle(
                        req.clone({
                            setHeaders: {
                                Authorization: BearerAuthSchema + ' ' + accessToken
                            }
                        })
                    )
                })
            );
    }

    private readonly refreshToken$ = of(1)
        .pipe(
            debounceTime(200),
            switchMap(() => this.accessCodeService.refreshToken()),
            share()
        );

    doRefreshIfRequired() {
        const [whenExpired$, whenActual$] = partition(
            forkJoin([of(this.accessTokenService.isTokenExpired()), of(this.accessTokenService.hasRefreshToken())]),
            ([isExpired, hasRefreshToken]) => isExpired && hasRefreshToken
        );

        return merge(
            whenExpired$.pipe(
                filter(([isExpired, hasRefreshToken]) => isExpired && hasRefreshToken),
                // tap(() => console.log('Token expired')),
                switchMap(() => this.refreshToken$),
                // tap(() => console.log('doRefreshIfRequired - after refresh')),
                map(x => x.access_token)
            ),

            whenActual$.pipe(
                switchMap(() => of(this.accessTokenService.getToken()))
            )
        );
    }
    
}
